import { Box } from '@mui/material'
import { OTHER_REST_COLOR } from '@yard/utils/color-scheme-palette'
import {
    BORDER_DEFAULT,
    BORDER_WIDTH_DEFAULT,
    OCCUPANCY_EMPTY,
} from '@yard/utils/occupancies.utils'
import { BlockColorSegment, MIN_DISTRIBUTION_SEGMENT_PX } from '../../stores/yard.view-store'

interface Props {
  segments: BlockColorSegment[]
  otherCount: number
  totalCount: number
  // True when the planner has the Rest bucket ticked. The "other" segment then
  // renders as Rest grey instead of the default white.
  isRestSelected?: boolean
}

const BAR_HEIGHT_PX = 12

export const BlockColorDistributionBar = ({
  segments,
  otherCount,
  totalCount,
  isRestSelected,
}: Props) => {
  if (totalCount <= 0) return null

  return (
    <Box
      data-testid='block-color-distribution-bar'
      sx={{
        display: 'flex',
        width: '100%',
        height: BAR_HEIGHT_PX,
        border: `${BORDER_WIDTH_DEFAULT} solid ${BORDER_DEFAULT}`,
        overflow: 'hidden',
      }}
    >
      {segments.map(segment => (
        <Box
          key={segment.value}
          data-testid={`block-color-distribution-segment-${segment.value}`}
          style={{ flexGrow: segment.count, minWidth: MIN_DISTRIBUTION_SEGMENT_PX }}
          sx={{ backgroundColor: segment.color }}
        />
      ))}
      {otherCount > 0 && (
        <Box
          data-testid='block-color-distribution-segment-other'
          style={{
            flexGrow: otherCount,
            backgroundColor: isRestSelected ? OTHER_REST_COLOR : OCCUPANCY_EMPTY,
          }}
        />
      )}
    </Box>
  )
}
